import React, { useState, useEffect } from 'react';
// import { Xbtn } from 'src/assets/index';


function NoticePopup(props) {
    const { onClose, noticeList} = { ...props };
	const [showNoticeList, setShowNoiceList] = useState(noticeList);


    useEffect(async () => {
        const len = showNoticeList.length;
        let cnt = 0;
        showNoticeList.map((item)=>{
            if(item.isOpen == false){
                cnt++;
            }
        })

        if(len == cnt){
            onClose();
        }

    },[showNoticeList]);


    function handleOnClick(seqNo) {
        setShowNoiceList(prevNoticeList => {
            const updatedNoticeList = prevNoticeList.map(item => {
                if (item.seqNo == seqNo) {
                    return {
                        ...item,
                        isOpen : false
                    };
                }
                return item; 
            });

            return updatedNoticeList;
        });


    }

    function closeTodayPop(seqNo){
        let expires = new Date();
        expires = expires.setHours(23, 59, 59, 0); //오늘 23시 59분 59초로 설정
        localStorage.setItem(seqNo, expires);
        //setShowMainPop(false);
        setShowNoiceList(prevNoticeList => {
            const updatedNoticeList = prevNoticeList.map(item => {
                if (item.seqNo === seqNo) {
                    return {
                        ...item,
                        isOpen : false
                    };
                }
                return item; 
            });

            return updatedNoticeList;
        });
        
    };

    return (
        <div className="popUp-wrapper">
        { showNoticeList
            ?
            showNoticeList.map((item) => {     
                return (

                item.isOpen ?
                    <div className="popUp-container noticePop">
                    <section className="popUp-box">
                        <div className='popUp-box-layout'>
                            <p className='popUp-title cnfmPopup'>{item.title}</p>
                            <p className='popUp-text notice-text' >
                                {item.text.split("\n").map((txt, index) => (
                                    <React.Fragment key={index}>
                                        {txt}
                                        <br />
                                    </React.Fragment>
                                ))}
                            </p>
                            <div >
                                <label htmlFor = {item.seqNo} className='noticec-check-text'>
                                    <input
                                        type='checkbox'
                                        id={item.seqNo}
                                        checked={localStorage.getItem(`${item.seqNo}`) !== null}
                                        onChange={() => closeTodayPop(item.seqNo)}
                                    />
                                    오늘 하루 더이상 보지 않기{console.log(localStorage.getItem(`${item.seqNo}`)!== null)}
                                </label>
                            </div>

                            <div className="btnBox">
                                <>
                                <button type="button" className="btn btnTwo btnCnfm" onClick={() => handleOnClick(item.seqNo)}>{item.btnNm}</button>
                                </>
                            </div>


                        </div>
                    </section>
                </div>
                :
                <></>
                    
            )
            })
            :
            <>               
            </>
        }

        </div>


        
    )
}

export default React.memo(NoticePopup)